import React, { useState, useCallback, useMemo } from "react";
import LivePl from "../LivePl/LivePl";

const fmt = require("indian-number-format");

export default function StandingCard({ item, userType }) {
  const [pfdata, setPfdata] = useState([]);

  const [total, setTotal] = useState(0);

  const [adminTotal, setAdminTotal] = useState(0);

  // ✅ Use callbacks instead of direct window functions for modularity
  const handleEdit = useCallback((type) => {
    window.user_id = item[`${type}_id`] || item.id;
    if (type === "super" && window.openeditSuper) window.openeditSuper();
    else if (type === "master" && window.masterModalOpen) window.masterModalOpen();
    else if (type === "user" && window.userModalOpen) window.userModalOpen();
  }, [item]);

  const LivePlTotal = useCallback((id, pf, admin_pf) => {
    if (!Array.isArray(item.standing) || item.standing.length === 0) return;

    setPfdata((prev) => {
      const existingIndex = prev.findIndex((i) => i.id === id);
      let updated = [...prev];

      if (existingIndex !== -1) {
        // Update existing
        updated[existingIndex] = { id, pf, admin_pf };
      } else {
        // Add new
        updated.push({ id, pf, admin_pf });
      }

      // Calculate totals immutably
      const totals = updated.reduce(
        (acc, cur) => {
          acc.total += parseFloat(cur.pf) || 0;
          acc.adminTotal += parseFloat(cur.admin_pf) || 0;
          return acc;
        },
        { total: 0, adminTotal: 0 }
      );

      setTotal(totals.total);

      setAdminTotal(totals.adminTotal);

      return updated;
    });
  }, [item.standing]);

  // ✅ Compute net total efficiently
  const netTotal = useMemo(() => {
    const totalValue =
      (parseFloat(total) || 0) + (parseFloat(item.profit_loss) || 0);
    return totalValue.toFixed(0);
  }, [total, item.profit_loss]);

  // ✅ Safe formatter wrapper
  const formatValue = useCallback(
    (val) => fmt.format(parseFloat(val || 0).toFixed(0)),
    []
  );

  return (
    <li key={item.id} className="menuContainer text addHight">
      {/* --- Live Profit/Loss Cards --- */}
      {Array.isArray(item.standing) && item.standing.length > 0 &&
        item.standing.map((i) => (
          <LivePl
            key={i.id}
            item={i}
            LivePlTotal={LivePlTotal}
          />
        ))}

      {/* --- Super Name --- */}
      {userType === 1 && (
        <div onClick={() => handleEdit("super")} className="menuExchange uppercase">
          <div className="user_id">{item.super_username}</div>
        </div>
      )}

      {/* --- Master Name --- */}
      {(userType === 1 || userType === 2) && (
        <div onClick={() => handleEdit("master")} className="menuExchange uppercase">
          <div className="user_id">{item.master_username}</div>
        </div>
      )}

      {/* --- User Name --- */}
      <div onClick={() => handleEdit("user")} className="menuExchange uppercase">
        <div className="user_id">{item.username}</div>
      </div>

      {/* --- Deposit Totals --- */}
      <div className="menuExchange">{formatValue(item.deposit_total)}</div>
      <div className="menuExchange">{formatValue(item.deposit_current)}</div>

      {/* --- Profit/Loss --- */}
      <div
        className={`menuExchange ${item.profit_loss > 0 ? "buytext" : "selltext"}`}
      >
        {formatValue(item.profit_loss)}
      </div>

      {/* --- Live PL Total --- */}
      <div className={`menuExchange ${total > 0 ? "buytext" : "selltext"}`}>
        {formatValue(total)}
      </div>

      {/* --- Net Total --- */}
      <div className={`menuExchange ${netTotal > 0 ? "buytext" : "selltext"}`}>
        {formatValue(netTotal)}
      </div>

      {/* --- Admin Total --- */}
      <div
        className={`menuExchange ${adminTotal < 0 ? "buytext" : "selltext"}`}
      >
        {formatValue(Math.abs(adminTotal))}
      </div>
    </li>
  );
}
